/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import { normalizeUnitOfMeasure } from '@shared/quantity';
import { buildCsvFromRows } from '../../../../shared/csv-core/infra/buildCsv';
import type { StockRow } from '../../domain/stockTypes';

const HEADERS = [
  'Producto',
  'SKU',
  'Codigo',
  'Marca',
  'Cantidad',
  'UnidadMedida',
  'Minimo',
  'CostoPromedio',
  'ValorStock',
  'PrecioVenta',
  'Vencimiento',
  'Proveedor',
  'Variante',
  'VariantSKU',
];

export function buildStockListCsv(rows: StockRow[]): string {
  const dataLines = rows.map((row) => {
    const stockValue = row.quantity * row.avgCost;
    const expiry = row.expiresAt ? row.expiresAt.slice(0, 10) : '';
    return [
      row.productName ?? '',
      row.productSku ?? '',
      row.productBarcode ?? '',
      row.productBrand ?? '',
      String(row.quantity),
      normalizeUnitOfMeasure(row.unitOfMeasure),
      String(row.minQuantity),
      String(row.avgCost),
      String(stockValue),
      String(Number(row.productPrice ?? 0)),
      expiry,
      row.productPreferredSupplier ?? '',
      // #801: Variant columns — empty for parent rows.
      row.variantLabel ?? '',
      row.variantSku ?? '',
    ];
  });
  return buildCsvFromRows(HEADERS, dataLines);
}
